import { QueryClient } from "@tanstack/react-query";

/**
 * Shared QueryClient instance with aggressive cache settings for memory optimization.
 *
 * This is exported so it can be used both in React components (via QueryClientProvider)
 * and in non-React code like Redux sagas for query invalidation.
 *
 * Cache settings:
 * - staleTime: 30s - Data is considered fresh for 30 seconds
 * - gcTime: 2min - Unused data is garbage collected after 2 minutes
 * - retry: 2 - Maximum 2 retry attempts on failure
 * - refetchOnWindowFocus: false - Don't refetch when window regains focus
 *
 * For specific queries that need different settings, override in the query hooks:
 * - User profile (changes rarely): staleTime: 5min, gcTime: 10min
 * - Drafts (changes frequently): staleTime: 10s, gcTime: 1min
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30 * 1000, // 30 seconds
      gcTime: 2 * 60 * 1000, // 2 minutes (garbage collection)
      retry: 2,
      refetchOnWindowFocus: false,
    },
  },
});
